// @ts-nocheck

import { createSelector } from 'reselect';

import { makeMatchIsMyMatchAvailableSelector } from '../../selectors/mymatch.selector';

const makeStickyMatchActionsRowPropsSelector = () =>
  createSelector([makeMatchIsMyMatchAvailableSelector()], (isMyMatchAvailable) => ({
    isMyMatchAvailable,
  }));

export default makeStickyMatchActionsRowPropsSelector;
